import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from 'react';

import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';
import { ThemeContext } from 'styled-components';

import api from 'services/api';

import Input from 'components/Input';
import Spinner from 'components/Spinner';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import ButtonGroup from 'components/ButtonGroup';
import { toast } from 'react-toastify';

import { VerticalTimelineElementProps } from 'react-vertical-timeline-component';

import {
  FiUpload,
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiUserCheck,
  FiMessageSquare,
  FiSend,
  FiUserX,
  FiUserMinus,
  FiDownloadCloud,
  FiCheck,
  FiMail,
} from 'react-icons/fi';

import { BsCheckAll } from 'react-icons/bs';

import { FaRobot, FaExchangeAlt } from 'react-icons/fa';
import { GoGear } from 'react-icons/go';

import { RiMailCloseLine, RiMailSendLine } from 'react-icons/ri';

import {
  VerticalTimeline,
  VerticalTimelineElement,
  FormMessage,
  VerticalTimelineContent,
  Scroll,
  AvatarContent,
} from './styles';
import Avatar from 'components/Avatar';

import { IRootState } from 'store/modules/rootReducer';
import { Usuario } from 'pages/@types';
import { FormHandles } from '@unform/core';

export interface ITimelineItem extends VerticalTimelineElementProps {
  _id: string;
  mensagem: string;
  tipo: string;
  usuario_id?: string;
  usuario?: Usuario;
  comercial_id?: number;
  midia_id?: number;
  chamada_id?: number;
  createdAt: string;
  updatedAt?: Date;
  // contentStyle: {
  //   background: string;
  //   color: string;
  //   padding: string;
  // };
}

interface IProps {
  data: ITimelineItem[];
  height?: string;
  chamadaId?: string | number;
  comercialId?: string | number;
  roteiroId?: string | number;
  layout: '2-columns' | '1-column';
  padding: string;
  handleAction?: () => void;
}

const Timeline: React.FC<IProps> = ({
  padding,
  data,
  height,
  chamadaId,
  comercialId,
  roteiroId,
  layout = '2-columns',
  handleAction,
}: IProps) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [activeFilter, setActiveFilter] = useState(1);
  const [timeline, setTimeline] = useState<ITimelineItem[]>(
    [] as ITimelineItem[],
  );
  const [filteredTimeline, setFilteredTimeline] = useState<ITimelineItem[]>(
    [] as ITimelineItem[],
  );

  const themeContext = useContext(ThemeContext);

  /**
   * REDUX
   */
  const { profile } = useSelector((state: IRootState) => state.usuario) as any;

  /**
   * USE REF
   */
  const formMessageRef = useRef<FormHandles>(null);

  /**
   * USE CALLBACK
   */
  const formatName = useCallback(
    (name: string | undefined, maxSize = 5): string => {
      if (!name) {
        return '';
      }

      if (name.length <= maxSize) {
        return name;
      } else {
        return name.slice(0, maxSize);
      }
    },
    [],
  );

  /**
   * USE EFFECT
   */
  useEffect(() => {
    const baseTimeline = {
      contentStyle: {
        background: themeContext?.timeline.balloon,
        color: themeContext?.tooltip.fontColor,
        padding: '1px 5px 10px 8px',
      },
      contentArrowStyle: {
        borderRight: `7px solid ${themeContext?.timeline.balloon}`,
      },
      iconStyle: {
        background: themeContext?.flag.cadastrado,
        // height: '45px',
        // width: '45px',
        // marginLeft: '-22.5px',
        color: themeContext?.lightFontColor,
      },
    };

    const timeline = data.map(item => {
      switch (item.tipo) {
        case 'cadastro':
          return {
            ...item,
            icon: <FiPlus />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
          };
        case 'edicao':
          return {
            ...item,
            icon: <FiEdit2 />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
          };
        case 'mensagem':
          return {
            ...item,
            icon: (
              <AvatarContent setor={item.usuario?.setor || 'opec'}>
                <Avatar
                  size="36"
                  round
                  src={item.usuario?.avatar_url}
                  name={item.usuario?.nome}
                />
                <span>{formatName(item.usuario?.setor)}</span>
              </AvatarContent>
            ),
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.emprocesso,
            },
          };
        case 'upload':
          return {
            ...item,
            icon: <FiUpload />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.chamada,
            },
          };
        case 'etapach':
          return {
            ...item,
            icon: <FaExchangeAlt />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.pendente,
            },
          };
        case 'aprovado':
          return {
            ...item,
            icon: <FiUserCheck />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.aprovado,
            },
          };
        case 'reprovado':
          return {
            ...item,
            icon: <FiUserX />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.reprovado,
            },
          };
        case 'emailenviado':
          return {
            ...item,
            icon: <RiMailSendLine />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.processado,
            },
          };
        case 'emailerror':
          return {
            ...item,
            icon: <RiMailCloseLine />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.reprovado,
            },
          };
        case 'ressalva':
          return {
            ...item,
            icon: <FiUserMinus />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.ressalva,
            },
          };
        case 'exibidor':
          return {
            ...item,
            icon: <BsCheckAll />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.chamada,
            },
          };
        case 'preavaliacao':
        case 'preavaliacao8Ch':
        case 'audio':
        case 'proxy':
          return {
            ...item,
            icon: <FaRobot />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.indisponivel,
            },
          };
        case 'avaliacaoeng':
          return {
            ...item,
            icon: <GoGear />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.edicao,
            },
          };
        case 'download':
          return {
            ...item,
            icon: <FiDownloadCloud />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
          };
        case 'envio':
          return {
            ...item,
            icon: <FiUpload />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.chamada,
            },
          };
        case 'planilha':
          return {
            ...item,
            icon: <FiCheck />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
            iconStyle: {
              ...baseTimeline.iconStyle,
              background: themeContext?.flag.chamada,
            },
          };
        default:
          return {
            ...item,
            icon: <FiPlus />,
            date: format(parseISO(item.createdAt), 'dd/MM/yyyy HH:mm:ss'),
            ...baseTimeline,
          };
      }
    });
    setTimeline(timeline);
    setFilteredTimeline(timeline);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, themeContext]);

  /**
   * USE CALLBACK
   */
  const updateLogs = useCallback(
    (newLog: ITimelineItem) => {
      const formatted = {
        ...newLog,
        icon: (
          <Avatar
            size="36"
            round
            src={newLog.usuario?.avatar_url}
            name={newLog.usuario?.nome}
          />
        ),
        date: format(parseISO(newLog.createdAt), 'dd/MM/yyyy HH:mm:ss'),
        contentStyle: {
          background: themeContext?.button.default.out,
          color: themeContext?.fontColor,
          padding: '1px 5px 10px 8px',
        },
        contentArrowStyle: {
          borderRight: `7px solid ${themeContext?.button.default.out}`,
        },
        iconStyle: {
          background: themeContext?.flag.emprocesso,
          color: themeContext?.fontColor,
          width: '48px',
          height: '48px',
        },
      };

      setTimeline([...timeline, formatted]);
      setFilteredTimeline([...timeline, formatted]);
    },
    [
      themeContext?.button.default.out,
      themeContext?.flag.emprocesso,
      themeContext?.fontColor,
      timeline,
    ],
  );

  /**
   * FUNÇÕES
   */
  const handleMessageSubmit = useCallback(
    async (_data: {
      mensagem: string;
      chamadaId?: string;
      comercialId?: string;
      roteiroId?: string;
    }) => {
      if (_data && _data.mensagem) {
        setLoadingSubmit(true);

        try {
          const data = Object.assign({
            mensagem: _data.mensagem,
            chamada_id: chamadaId,
            comercial_id: comercialId,
            roteiro_id: roteiroId,
          });
          await api.post('/logs', data).then(response => {
            if (formMessageRef.current) formMessageRef.current.reset();
            updateLogs(response.data);
          });

          // } catch (err) {
          //   toast.error(err.message || err);
          //   setLoadingSubmit(false);
          // }
        } catch (e) {
          if (e instanceof Error) toast.error(e.message || e);
          else toast.error('Erro inesperado');
        } finally {
          setLoadingSubmit(false);
        }
      }
    },
    [chamadaId, comercialId, roteiroId, updateLogs],
  );

  async function handleDeleteMessage() {
    // quando deletado colocar mensagem "Mensagem removida pelo usuário"
    alert('Função em desenvolvimento');
  }

  const filterTimeline = useCallback(
    filter => {
      setActiveFilter(filter);
      switch (filter) {
        case 2:
          setFilteredTimeline(timeline.filter(tl => !tl.usuario));
          break;
        case 3:
          setFilteredTimeline(timeline.filter(tl => !!tl.usuario));
          break;
        default:
          setFilteredTimeline(timeline);
          break;
      }
    },
    [timeline],
  );

  const footer = useCallback(
    ({ date, profile, usuario }) => {
      return (
        <>
          {!!usuario && (
            <span>Por {profile.id === usuario.id ? 'Você' : usuario.nome}</span>
          )}
          {layout === '1-column' && <strong>em {date}</strong>}
        </>
      );
    },
    [layout],
  );

  return (
    <>
      <Scroll
        height={height}
        options={{ suppressScrollX: true }}
        padding={padding}
      >
        <ButtonGroup activeButton={activeFilter}>
          <button onClick={() => filterTimeline(1)}>Todos</button>
          <button onClick={() => filterTimeline(2)}>Sistema</button>
          <button onClick={() => filterTimeline(3)}>Usuário</button>
        </ButtonGroup>
        <VerticalTimeline layout={layout}>
          {!!filteredTimeline &&
            filteredTimeline.length > 0 &&
            filteredTimeline.map(item => (
              <VerticalTimelineElement
                key={item._id}
                className="vertical-timeline-element--work"
                contentStyle={item.contentStyle}
                contentArrowStyle={item.contentArrowStyle}
                date={item.date}
                iconStyle={item.iconStyle}
                icon={item.icon}
                layout={layout}
                // onTimelineElementClick={() => console.log('teste')}
              >
                <VerticalTimelineContent>
                  <div>
                    <p>{item.mensagem}</p>
                    {footer({
                      date: item.date,
                      usuario: item.usuario,
                      profile,
                    })}
                  </div>
                  {item.tipo === 'mensagem' &&
                    item.usuario_id === profile.id && (
                      <>
                        <Button
                          fill
                          round
                          onClick={() => handleDeleteMessage()}
                          id={`id_delete${item.id}`}
                        >
                          <FiTrash2 />
                        </Button>
                        <Tooltip target={`id_delete${item.id}`}>
                          DELETAR
                        </Tooltip>
                      </>
                    )}{' '}
                  {(item.tipo === 'emailenviado' ||
                    item.tipo === 'emailerror') &&
                    handleAction && (
                      <>
                        <Button
                          fill
                          round
                          onClick={() => handleAction()}
                          id={`id_action${item.id}`}
                        >
                          <FiMail />
                        </Button>
                        <Tooltip target={`id_action${item.id}`}>
                          REENVIAR
                        </Tooltip>
                      </>
                    )}
                </VerticalTimelineContent>
              </VerticalTimelineElement>
            ))}
        </VerticalTimeline>
      </Scroll>
      <FormMessage ref={formMessageRef} onSubmit={handleMessageSubmit}>
        <Input
          name="mensagem"
          type="text"
          icon={<FiMessageSquare />}
          placeholder="Deixe uma observação"
          disabled={loadingSubmit}
        />
        <Button
          color="primary"
          type="submit"
          disabled={loadingSubmit}
          tooltip=""
        >
          {!loadingSubmit ? <FiSend /> : <Spinner type="ThreeDots" />}
        </Button>
      </FormMessage>
    </>
  );
};

export default Timeline;
